import React, { useEffect } from "react"
import H1TitleId from "../components/title/H1TitleId"
import PageContent from '../components/util/PageContent'
import BigButtonWithTextAtBottom from "../components/bigButton/BigButtonWithTextAtBottom"
import GetStrLocalized from "../datas/GetStrLocalized"
import GetHtmlStrLocalized from "../datas/GetHtmlStrLocalized"
import { HcContext } from "../types/hccontext"


interface ReadingsProps {
	language: string;
	setDocumentTitle: React.Dispatch<React.SetStateAction<string>>;
	hcContext: HcContext;
}

interface YouTubeIdProps {
	videoId: string;
}

function Readings({ language, setDocumentTitle, hcContext }: Readonly<ReadingsProps>) {

	useEffect(() => {
		setDocumentTitle(GetStrLocalized(language, "readings") + " - Holy Chatter");
	}, [setDocumentTitle, language]);

	function SmallYoutubePlayer({ videoId }: YouTubeIdProps) {
		return <iframe className="hc-big-button-normal-height hc-big-button-normal-width hc-small-margin" allowFullScreen frameBorder="0"
			src={"https://www.youtube.com/embed/" + videoId + "?rel=0&playsinline=1"} referrerPolicy="strict-origin-when-cross-origin" title={"Video  " + videoId} style={{ marginLeft: '50px' }}></iframe>
	}
	const biblePath = "/" + language + "/" + GetStrLocalized(language, "readingsFolderName") + "/" + GetStrLocalized(language, "bibleFolderName")
	const cccPath = "/" + language + "/" + GetStrLocalized(language, "readingsFolderName") + "/" + GetStrLocalized(language, "catechismOfTheCatholicChurchFolderName")
	const papalTextsPath = "/" + language + "/" + GetStrLocalized(language, "readingsFolderName") + "/" + GetStrLocalized(language, "papalTextsFolderName")
	const theSocialDoctrineOfTheChurchUrl = GetStrLocalized(language, "theSocialDoctrineOfTheChurchUrl")


	return (
		<PageContent>
			<H1TitleId language={language} titleId="readings" />
			<br /><br />

			<table className='hc-categories-left-margin'>
				<thead className="visually-hidden"><tr><th></th></tr></thead>
				<tbody>
					<tr>
						<td style={{ width: '33%', paddingLeft: '5px', paddingRight: '15px' }}>
							<BigButtonWithTextAtBottom link={biblePath} image="/buttons/bible.jpg" duration="" title={GetStrLocalized(language, "bible")} tags="" beginOfClassName="hc-big-button-normal" hcContext={hcContext} />
						</td>
						<td className="hc-long-screen" style={{ width: '33%', paddingLeft: '15px', paddingRight: '15px' }}>
							<SmallYoutubePlayer videoId={language === "fr" ? "pYYIYRhlVoI" : "ak06MSETeo4"} />
						</td>
						<td className="hc-long-screen hc-content-text" style={{ width: '34%', paddingLeft: '15px', paddingRight: '5px' }}>
							<div>
								<div className='hc-small-margin' style={{ paddingTop: '10px', paddingLeft: '10px' }}><b><GetHtmlStrLocalized language={language} textId="plan" /></b><br /></div>
								<div className='hc-small-margin' style={{ paddingTop: '5px', paddingLeft: '10px' }}><a href={biblePath + "/" + GetStrLocalized(language, "oldTestamentFolderName")}>1) <GetHtmlStrLocalized language={language} textId="oldTestament" /></a><br /></div>
								<div className='hc-small-margin' style={{ paddingTop: '5px', paddingLeft: '10px' }}><a href={biblePath + "/" + GetStrLocalized(language, "newTestamentFolderName")}>2) <GetHtmlStrLocalized language={language} textId="newTestament" /></a><br /></div>
							</div>
						</td>
					</tr>

					<tr>
						<td style={{ width: '33%', paddingLeft: '5px', paddingRight: '15px' }}>
							<BigButtonWithTextAtBottom link={cccPath} image="/buttons/rosace.jpg" duration="" title={GetStrLocalized(language, "catechismOfTheCatholicChurch")} tags="" beginOfClassName="hc-big-button-normal" hcContext={hcContext} />
						</td>
						<td className="hc-long-screen" style={{ width: '33%', paddingLeft: '15px', paddingRight: '15px' }}>
							<SmallYoutubePlayer videoId={language === "fr" ? "65XIj6HiVag" : "MhScAGLQBEU"} />
						</td>
						<td className="hc-long-screen hc-content-text" style={{ width: '34%', paddingLeft: '15px', paddingRight: '5px' }}>
							<div>
								<div className='hc-small-margin' style={{ paddingTop: '10px', paddingLeft: '10px' }}><b><GetHtmlStrLocalized language={language} textId="plan" /></b><br /></div>
								<div className='hc-small-margin' style={{ paddingLeft: '10px' }}><a href={cccPath + "/" + GetStrLocalized(language, "prologueFolderName")}>1) <GetHtmlStrLocalized language={language} textId="prologue" /></a><br /></div>
								<div className='hc-small-margin' style={{ paddingLeft: '10px' }}><a href={cccPath + "/" + GetStrLocalized(language, "theProfessionOfFaithFolderName")}>2) <GetHtmlStrLocalized language={language} textId="theProfessionOfFaith" /></a><br /></div>
								<div className='hc-small-margin' style={{ paddingLeft: '10px' }}><a href={cccPath + "/" + GetStrLocalized(language, "theCelebrationOfChristianMisteryFolderName")}>3) <GetHtmlStrLocalized language={language} textId="theCelebrationOfChristianMistery" /></a><br /></div>
								<div className='hc-small-margin' style={{ paddingLeft: '10px' }}><a href={cccPath + "/" + GetStrLocalized(language, "lifeInChristFolderName")}>4) <GetHtmlStrLocalized language={language} textId="lifeInChrist" /></a><br /></div>
								<div className='hc-small-margin' style={{ paddingLeft: '10px' }}><a href={cccPath + "/" + GetStrLocalized(language, "christianPrayerFolderName")}>5) <GetHtmlStrLocalized language={language} textId="christianPrayer" /></a><br /></div>
							</div>
						</td>
					</tr>


					<tr>
						<td style={{ width: '33%', paddingLeft: '5px', paddingRight: '15px' }}>
							<BigButtonWithTextAtBottom link={papalTextsPath} image="/buttons/pope_writing.jpg" duration="" title={GetStrLocalized(language, "papalTexts")} tags="" beginOfClassName="hc-big-button-normal" hcContext={hcContext} />
						</td>
						<td className="hc-long-screen" style={{ width: '33%', paddingLeft: '15px', paddingRight: '15px' }}>
							{language === "fr" && <SmallYoutubePlayer videoId="QQEbU_VLAhs" />}
						</td>
						<td className="hc-long-screen hc-content-text" style={{ width: '34%', paddingLeft: '15px', paddingRight: '5px' }}>
							<div>
								<div className='hc-small-margin' style={{ paddingTop: '10px', paddingLeft: '10px' }}><b><GetHtmlStrLocalized language={language} textId="examples" /></b><br /></div>
								<div className='hc-small-margin' style={{ paddingLeft: '10px' }}><a href={papalTextsPath}><GetHtmlStrLocalized language={language} textId="encyclicLetterPatrisCorde" /></a><br /></div>
								{language === "fr" && <div className='hc-small-margin' style={{ paddingLeft: '10px' }}><a href={papalTextsPath}><GetHtmlStrLocalized language={language} textId="encyclicalFratelliTutti" /></a><br /></div>}
								{language === "fr" && <div className='hc-small-margin' style={{ paddingLeft: '10px' }}><a href={papalTextsPath}><GetHtmlStrLocalized language={language} textId="encyclicalLaudatoSi" /></a><br /></div>}
							</div>
						</td>
					</tr>
				</tbody>
			</table>


			<br />
			<div style={{ paddingLeft: '20px' }}>
				<b className='hc-button-title-style'><GetHtmlStrLocalized language={language} textId="theSocialDoctrineOfTheChurch" /></b><br />
				<a href={theSocialDoctrineOfTheChurchUrl} style={{ wordWrap: 'break-word' }}>{theSocialDoctrineOfTheChurchUrl}</a>
			</div>


		</PageContent>
	)
}

export default Readings;